import './ppt.scss'
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

const PptPage = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const [url, setUrl] = useState('')

  useEffect(() => {
    const paramUrl = params.get('url') || ''
    if (paramUrl) {
      setUrl(paramUrl)
      localStorage.setItem('pptUrl', paramUrl)
      return
    }

    const cachedUrl = localStorage.getItem('pptUrl') || ''
    setUrl(cachedUrl)
  }, [params])

  const goBack = () => {
    navigate(-1)
  }

  return (
    <div className="ppt-page">
      {/* <div className="ppt-header">
        <button className="ppt-back" onClick={goBack}>
          返回
        </button>
        <div className="ppt-title">课件预览</div>
      </div> */}
      <div className="ppt-body">
        {url ? (
          <iframe
            className="ppt-iframe"
            src={url}
            title="PPT"
            frameBorder="0"
            allowFullScreen
          />
        ) : (
          <div className="ppt-empty">未找到课件链接</div>
        )}
      </div>
    </div>
  )
}

export default PptPage
